<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM11.9 6.7L10 8.6L8.1 6.7C7.9 6.5 7.7 6.4 7.4 6.4C7.1 6.4 6.9 6.5 6.7 6.7C6.3 7.1 6.3 7.7 6.7 8.1L8.6 10L6.7 11.9C6.3 12.3 6.3 12.9 6.7 13.3C7.1 13.7 7.7 13.7 8.1 13.3L10 11.4L11.9 13.3C12.3 13.7 12.9 13.7 13.3 13.3C13.7 12.9 13.7 12.3 13.3 11.9L11.4 10L13.3 8.1C13.7 7.7 13.7 7.1 13.3 6.7C12.9 6.3 12.3 6.3 11.9 6.7ZM2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10Z" fill="white"></path>
</template>

<script>
    export default {
        name: 'icon-error'
    }
</script>